"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SocketMessageMapping = void 0;
var _genericFunction = require("../genericFunction");
var SocketMessageMapping = [{
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/bulk/platform/activate",
  method: "PUT",
  message: "User(s) unsuspending."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/bulk/platform/deactivate",
  method: "PUT",
  message: "User(s) suspending."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api//user/bulk/platform/delete/hard",
  method: "PUT",
  message: "User(s) hard deleting."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/account/bulk/enable",
  method: "PUT",
  message: "Account(s) enabling."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/account/bulk/disable",
  method: "PUT",
  message: "Account(s) disabling."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/account/bulk/delete",
  method: "PUT",
  message: "Account(s) deleting."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/account/bulk/restore",
  method: "PUT",
  message: "Account(s) restoring."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/account/bulk/clean",
  method: "PUT",
  message: "Account(s) cleaning."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/account/bulk/delete-permanent",
  method: "PUT",
  message: "Account(s) deleting permanently."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/user/preflight",
  method: "POST",
  message: "Preflighting user(s) data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/user",
  method: "POST",
  message: "Importing user(s) data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/recipient/preflight",
  method: "POST",
  message: "Preflighting recipient(s) data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/recipient",
  method: "POST",
  message: "Importing recipient(s) data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/tenant-data/preflight",
  method: "POST",
  message: "Preflighting tenant(s) data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/data-map/preflight",
  method: "POST",
  message: "Preflighting data map.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/data-map",
  method: "POST",
  message: "Importing data map.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/tenant-data",
  method: "POST",
  message: "Importing user(s) data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/type",
  method: "POST",
  message: "Fund type uploading."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/bulk/activate",
  method: "PUT",
  message: "User(s) unsuspending."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/bulk/deactivate",
  method: "PUT",
  message: "User(s) suspending."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/bulk/delete/hard",
  method: "PUT",
  message: "User(s) deleting."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/preflight",
  method: "POST",
  message: "Preflighting fund details.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund",
  method: "POST",
  message: "Importing fund details.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "importservice/v1/api/import/fund/performance/preflight",
  method: "POST",
  message: "Preflighting FY performance data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "importservice/v1/api/import/fund/performance",
  method: "POST",
  message: "Importing FY performance data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/donors/preflight",
  method: "POST",
  message: "Preflighting FY donor data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/performance/preflight",
  method: "POST",
  message: "Preflighting FY performance data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/performance",
  method: "POST",
  message: "Importing FY performance data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/donors",
  method: "POST",
  message: "Importing FY donor data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/impact/preflight",
  method: "POST",
  message: "Preflighting FY impact data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/impact",
  method: "POST",
  message: "Importing FY impact data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/asset/preflight",
  method: "POST",
  message: "Preflighting fund assets.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/asset",
  method: "POST",
  message: "Importing fund assets.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/performance/fy/preflight",
  method: "POST",
  message: "Preflighting FY performance data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/performance/fy",
  method: "POST",
  message: "Importing FY performance data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/impact/fy/asset/preflight",
  method: "POST",
  message: "Preflighting FY impact assets.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/impact/fy/asset",
  method: "POST",
  message: "Importing FY impact assets.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/impact/fy/preflight",
  method: "POST",
  message: "Preflighting FY impact data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/fund/impact/fy",
  method: "POST",
  message: "Importing FY impact data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/record/giving/preflight",
  method: "POST",
  message: "Preflighting record givings.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/record/giving",
  method: "POST",
  message: "Importing record givings.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/record/fy/preflight",
  method: "POST",
  message: "Preflighting record FY asset.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/record/fy",
  method: "POST",
  message: "Importing record FY asset.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/record/preflight",
  method: "POST",
  message: "Preflighting record(s) data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/record",
  method: "POST",
  message: "Importing record(s) data.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records/bulk/delete/soft",
  method: "PUT",
  message: "Record(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records/bulk/delete/hard",
  method: "PUT",
  message: "Record(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/site/bulk",
  method: "POST",
  message: "Site(s) created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/bulk",
  method: "POST",
  message: "Report(s) created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/put",
  method: "PUT",
  message: "Report deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/bulk",
  method: "POST",
  message: "Site(s) created."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/bulk/delete",
  method: "PUT",
  message: "Site(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/bulk/submit",
  method: "PUT",
  message: "Site(s) submitted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/bulk/resume",
  method: "PUT",
  message: "Sites are live."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/bulk/pause",
  method: "PUT",
  message: "Site(s) paused."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/bulk/alert/on",
  method: "PUT",
  message: "Site(s) alerts on for record owners."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/bulk/alert/off",
  method: "PUT",
  message: "Site(s) alerts off for record owners."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/bulk/restricted",
  method: "PUT",
  message: "Site(s) restricted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/bulk/unrestricted",
  method: "PUT",
  message: "Site(s) access allowed."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/bulk/lock",
  method: "PUT",
  message: "Site(s) locked."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/bulk/unlock",
  method: "PUT",
  message: "Site(s) unlocked."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/bulk",
  method: "PUT",
  message: "Report(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/bulk/submit",
  method: "PUT",
  message: "Report(s) submitted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/bulk/resume",
  method: "PUT",
  message: "Reports are live."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/bulk/pause",
  method: "PUT",
  message: "Report(s) paused."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/bulk/alert/on",
  method: "PUT",
  message: "Report(s) alerts on for record owners."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/bulk/alert/off",
  method: "PUT",
  message: "Report(s) alerts off for record owners."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/bulk/restricted",
  method: "PUT",
  message: "Report(s) restricted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/bulk/unrestricted",
  method: "PUT",
  message: "Report(s) access allowed."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/bulk/lock",
  method: "PUT",
  message: "Report(s) locked."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/bulk/unlock",
  method: "PUT",
  message: "Report(s) unlocked."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/system/user",
  method: "GET",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/system/record",
  method: "GET",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/report/data/fund",
  method: "GET",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/report/data/performance",
  method: "GET",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/report/data/donor",
  method: "GET",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/report/data/impact",
  method: "GET",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/report/data/distribution",
  method: "GET",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/site/distribution",
  method: "GET",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/print-bridge/report",
  method: "GET",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/analytics/report/snapshot/live",
  method: "GET",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/analytics/site/snapshot/live",
  method: "GET",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/analytics/record/snapshot",
  method: "GET",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/analytics/record/site-report/system-wide-data",
  method: "GET",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/archive",
  method: "DELETE",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund/bulk/delete",
  method: "PUT",
  message: "Fund(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/bulk/approve",
  method: "PUT",
  message: "Report(s) approved & URL activated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/bulk/approve",
  method: "PUT",
  message: "Site(s) approved & URL activated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/survey/recipient/response/bulk/approve",
  method: "PUT",
  message: "Survey(s) approved; data transferred."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records/delete/hard",
  method: "DELETE",
  message: "Record deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/recordsservice/v1/api/records/bulk/delete/soft/restore",
  method: "PUT",
  message: "Record(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/donors/bulk/hard/delete",
  method: "PUT",
  message: "FY donor data deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/performance/bulk/hard/delete",
  method: "PUT",
  message: "FY performance data deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact/bulk/hard/delete",
  method: "PUT",
  message: "FY impact data deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/system/user-activity",
  method: "GET",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/bulk/clone",
  method: "POST",
  message: "Site duplicated."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/bulk/platform/delete/hard",
  method: "PUT",
  message: "User(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/mailservice/v1/api/email-templates/bulk/delete/hard",
  method: "PUT",
  message: "Email(s) template deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset/upload/bulk",
  method: "POST",
  message: "Asset(s) uploaded.",
  dynamic: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/analyticsservice/v1/api/analytics/session/bulk/delete",
  method: "PUT",
  message: "Activity(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/printbridge/report/pdf",
  method: "POST",
  message: "File downloaded."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/platform/user",
  method: "GET",
  message: "File downloaded."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/tenant-data",
  method: "GET",
  message: "File downloaded."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/data-map",
  method: "GET",
  message: "File downloaded."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/analyticsservice/v1/api/analytics/snapshot/download/live/site",
  method: "GET",
  message: "File downloaded."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/analyticsservice/v1/api/analytics/snapshot/download/live/report",
  method: "GET",
  message: "File downloaded."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/template/file/download",
  method: "GET",
  message: "File downloaded."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/bulk/delete/soft",
  method: "PUT",
  message: "User(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/bulk/delete/soft/restore",
  method: "PUT",
  message: "User(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/bulk/delete/soft",
  method: "PUT",
  message: "Report(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportservice/v1/api/report/bulk/delete/soft/restore",
  method: "PUT",
  message: "Report(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/bulk/delete/soft",
  method: "PUT",
  message: "Site(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/sitesservice/v1/api/site/bulk/delete/soft/restore",
  method: "PUT",
  message: "Site(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund/bulk/delete/soft",
  method: "PUT",
  message: "Fund(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund/bulk/delete/soft/restore",
  method: "PUT",
  message: "Fund(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact/bulk/delete/soft/restore",
  method: "PUT",
  message: "FY impact data restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset/folder/bulk/delete/hard",
  method: "PUT",
  message: "Asset(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/assetsservice/v1/api/asset/folder/bulk/delete/soft/restore",
  method: "PUT",
  message: "Asset(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/performance/bulk/delete/soft/restore",
  method: "PUT",
  message: "FY performance data restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/folder-view/bulk/delete/soft/restore",
  method: "PUT",
  message: "Content panel(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/content-panel/folder-view/bulk/delete/hard",
  method: "PUT",
  message: "Content panel(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/donors/bulk/delete/soft",
  method: "PUT",
  message: "FY donor data soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/donors/bulk/delete/soft/restore",
  method: "PUT",
  message: "FY donor data restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/crm/field-mapping",
  method: "POST",
  message: "Importing custom column name.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/importservice/v1/api/import/crm/field-mapping/preflight",
  method: "POST",
  message: "Preflighting custom column name.",
  isImport: true
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/bulk/platform/delete/soft",
  method: "PUT",
  message: "User(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/userservice/v1/api/user/bulk/platform/delete/soft/restore",
  method: "PUT",
  message: "User(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/mailservice/v1/api/email-templates/bulk/delete/soft",
  method: "PUT",
  message: "Email template(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/mailservice/v1/api/email-templates/bulk/delete/soft/restore",
  method: "PUT",
  message: "Email template(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/broadcast/templates/bulk/delete/soft/restore",
  method: "PUT",
  message: "Broadcast(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/broadcast/templates/bulk/delete/hard",
  method: "PUT",
  message: "Broadcast(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/platform/brand/bulk/delete/soft/restore",
  method: "PUT",
  message: "Brand(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/platform/brand/bulk/delete/hard",
  method: "PUT",
  message: "Brand(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/standard/template/bulk/delete/soft/restore",
  method: "PUT",
  message: "Content panel(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/standard/template/bulk/delete/hard",
  method: "PUT",
  message: "Content panel(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund/type/bulk/delete/soft/restore",
  method: "PUT",
  message: "Fund type(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/bulk/fund/delete/soft/restore",
  method: "PUT",
  message: "Access criteria(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund/type/bulk/delete/hard",
  method: "PUT",
  message: "Fund type(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/bulk/fund/delete/hard",
  method: "PUT",
  message: "Access criteria(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact/type/bulk/delete/soft/restore",
  method: "PUT",
  message: "Impact type(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/bulk/fund/performance/delete/soft/restore",
  method: "PUT",
  message: "Access criteria(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact/type/bulk/delete/hard",
  method: "PUT",
  message: "Impact type(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/bulk/fund/performance/delete/hard",
  method: "PUT",
  message: "Access criteria(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel/bulk/delete/soft/restore",
  method: "PUT",
  message: "Rdt panel html(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/bulk/fund/donor/delete/soft/restore",
  method: "PUT",
  message: "Access criteria(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel/bulk/delete/hard",
  method: "PUT",
  message: "Rdt panel html(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/bulk/fund/donor/delete/hard",
  method: "PUT",
  message: "Access criteria(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel/mapping/bulk/delete/hard",
  method: "PUT",
  message: "Map rdt panel(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/bulk/fund/impact/delete/soft/restore",
  method: "PUT",
  message: "Access criteria(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel/mapping/bulk/delete/soft/restore",
  method: "PUT",
  message: "Map rdt panel(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/standard/print-bridge/bulk/site/delete/soft/restore",
  method: "PUT",
  message: "Content panel printbridge(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/standard/print-bridge/bulk/site/delete/hard",
  method: "PUT",
  message: "Content panel printbridge(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/printbridge/report/bulk/delete/hard",
  method: "PUT",
  message: "Report printbridge(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/printbridgeservice/v1/api/printbridge/report/bulk/delete/soft/restore",
  method: "PUT",
  message: "Report printbridge(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/report/data/access-criteria/bulk/fund/impact/delete/hard",
  method: "PUT",
  message: "Access criteria(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/broadcast/templates/bulk/delete/soft",
  method: "PUT",
  message: "Broadcast(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/platform/brand/bulk/delete/soft",
  method: "PUT",
  message: "Brand(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/standard/template/bulk/delete/soft",
  method: "PUT",
  message: "Content panel(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/fund/type/bulk/delete/soft",
  method: "PUT",
  message: "Fund type(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/reportdataservice/v1/api/report/data/impact/type/bulk/delete/soft",
  method: "PUT",
  message: "Impact type(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel/bulk/delete/soft",
  method: "PUT",
  message: "Rdt panel html(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/report-panel/mapping/bulk/delete/soft",
  method: "PUT",
  message: "Rdt panel map(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/templates/contents/bulk/delete/soft/restore",
  method: "PUT",
  message: "Site elements(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/templates/contents/bulk/report/delete/soft/restore",
  method: "PUT",
  message: "Report elements(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/templates/contents/bulk/delete/hard",
  method: "PUT",
  message: "Site elements(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/templates/contents/bulk/report/delete/hard",
  method: "PUT",
  message: "Report elements(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/palette/bulk/delete/hard",
  method: "PUT",
  message: "Palette(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/palette/bulk/delete/soft/restore",
  method: "PUT",
  message: "Palette(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/platformservice/v1/api/palette/bulk/delete/soft",
  method: "PUT",
  message: "Palette(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/system/log",
  method: "GET",
  message: "Data added to Export Archive for download."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/interaction-panel/template/bulk/delete/soft",
  method: "PUT",
  message: "Interaction panel(s) soft-deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/interaction-panel/template/bulk/delete/soft/restore",
  method: "PUT",
  message: "Interaction panel(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/interaction-panel/template/bulk/delete/hard",
  method: "PUT",
  message: "Interaction panel(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/interaction-panel/response/download",
  method: "GET",
  message: "Response downloaded."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/interaction-panel/type/bulk/delete/soft",
  method: "PUT",
  message: "IP folder(s) soft deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/interaction-panel/type/bulk/delete/hard",
  method: "PUT",
  message: "IP folder(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/contentpanelservice/v1/api/interaction-panel/type/bulk/delete/soft/restore",
  method: "PUT",
  message: "IP folder(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/survey/bulk/resume",
  method: "PUT",
  message: "Survey are live."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/survey/bulk/pause",
  method: "PUT",
  message: "Survey(s) paused."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/survey/bulk/lock",
  method: "PUT",
  message: "Survey(s) locked."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/survey/bulk/unlock",
  method: "PUT",
  message: "Survey(s) unlocked."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/survey/bulk/delete/soft",
  method: "PUT",
  message: "Survey(s) soft deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/survey/bulk/delete/soft/restore",
  method: "PUT",
  message: "Survey(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/survey/bulk/delete",
  method: "PUT",
  message: "Survey(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/survey",
  method: "GET",
  message: "Survey downloaded."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/recipient/bulk/delete",
  method: "PUT",
  message: "Recipient(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/recipient/bulk/delete/soft",
  method: "PUT",
  message: "Recipient(s) soft deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/recipient/bulk/delete",
  method: "PUT",
  message: "Recipient(s) deleted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/recipient/bulk/delete/soft/restore",
  method: "PUT",
  message: "Recipient(s) restored."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/survey/recipient/response/bulk/lock",
  method: "PUT",
  message: "Recipient(s) locked."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/survey/recipient/response/bulk/unlock",
  method: "PUT",
  message: "Recipient(s) unlocked."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/surveyorservice/v1/api/survey/recipient/response/bulk/submit",
  method: "PUT",
  message: "Recipient(s) submitted."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/recipient",
  method: "GET",
  message: "Recipient details downloaded."
}, {
  url: (0, _genericFunction.getApiGatewayUrl)() + "/exportservice/v1/api/export/interaction-panel/response",
  method: "GET",
  message: "Interaction data downloaded."
}];
exports.SocketMessageMapping = SocketMessageMapping;
var _default = SocketMessageMapping;
exports.default = _default;